import { defineStore } from "pinia";

export const usePersonalizedVariableStore = defineStore('personalizedVariable', {
    state: () => ({
        personalizedVariable: {},
        personalizedVariables: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setPersonalizedVariable(personalizedVariable) {
            this.personalizedVariable = personalizedVariable
        },
        setPersonalizedVariables(personalizedVariables) {
            this.personalizedVariables = personalizedVariables
        },
        addPersonalizedVariable(personalizedVariable) {
            this.personalizedVariables.unshift(personalizedVariable)
        },
        updatePersonalizedVariable(personalizedVariable) {
            let index = this.personalizedVariables.findIndex(cl => cl.id === personalizedVariable.id)
            this.personalizedVariables.splice(index, 1, personalizedVariable)
        },
        deletePersonalizedVariable(personalizedVariable) {
            let index = this.personalizedVariables.findIndex(cl => cl.id === personalizedVariable.id)
            this.personalizedVariables.splice(index, 1)
        },
    },
});